import React, { useState } from "react";
import styles from "./Applicants.module.css";

function Applicants({ formData, setFormData }) {
  const [hasApplicant2, setHasApplicant2] = useState(
    formData.hasApplicant2 || false
  );

  const updateApplicant = (applicant, field, value) => {
    const updated = {
      ...formData,
      [applicant]: {
        ...(formData[applicant] || {}),
        [field]: value,
      },
    };
    setFormData(updated);
  };

  return (
    <div className={styles.container}>
      <h3>Applicants</h3>

      {/* Applicant 1 */}
      <div className={styles.section}>
        <h4>Applicant 1 - Primary</h4>
        <div className={styles.row}>
          <input
            placeholder="Full Name"
            value={formData.applicant1?.name || ""}
            onChange={(e) => updateApplicant("applicant1", "name", e.target.value)}
          />
          <input
            placeholder="Phone"
            value={formData.applicant1?.phone || ""}
            onChange={(e) => updateApplicant("applicant1", "phone", e.target.value)}
          />
          <input
            placeholder="Email"
            value={formData.applicant1?.email || ""}
            onChange={(e) => updateApplicant("applicant1", "email", e.target.value)}
          />
        </div>

        <div className={styles.row}>
          <input
            type="date"
            placeholder="Date of Birth"
            value={formData.applicant1?.dob || ""}
            onChange={(e) => updateApplicant("applicant1", "dob", e.target.value)}
          />
          <select
            value={formData.applicant1?.maritalStatus || ""}
            onChange={(e) =>
              updateApplicant("applicant1", "maritalStatus", e.target.value)
            }
          >
            <option value="">Marital Status</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Defacto">Defacto</option>
            <option value="Separated">Separated</option>
          </select>
          <select
            value={formData.applicant1?.residency || ""}
            onChange={(e) =>
              updateApplicant("applicant1", "residency", e.target.value)
            }
          >
            <option value="">Residency Status</option>
            <option value="Citizen">Citizen</option>
            <option value="Permanent Resident">Permanent Resident</option>
            <option value="Temporary Resident">Temporary Resident</option>
          </select>
        </div>

        <div className={styles.row}>
          <input
            placeholder="Employer"
            value={formData.applicant1?.employer || ""}
            onChange={(e) =>
              updateApplicant("applicant1", "employer", e.target.value)
            }
          />
          <input
            placeholder="Income ($)"
            type="number"
            value={formData.applicant1?.income || ""}
            onChange={(e) =>
              updateApplicant("applicant1", "income", e.target.value)
            }
          />
          <select
            value={formData.applicant1?.employmentType || ""}
            onChange={(e) =>
              updateApplicant("applicant1", "employmentType", e.target.value)
            }
          >
            <option value="">Employment Type</option>
            <option value="PAYG Full-time">PAYG Full-time</option>
            <option value="PAYG Part-time">PAYG Part-time</option>
            <option value="Casual">Casual</option>
            <option value="Self-Employed">Self-Employed</option>
            <option value="Contractor">Contractor</option>
          </select>
        </div>
      </div>

      {/* Applicant 2 Toggle */}
      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={hasApplicant2}
          onChange={() => {
            setHasApplicant2(!hasApplicant2);
            setFormData({ ...formData, hasApplicant2: !hasApplicant2 });
          }}
        />
        Add Second Applicant
      </label>

      {/* Applicant 2 */}
      {hasApplicant2 && (
        <div className={styles.section}>
          <h4>Applicant 2 - Secondary</h4>
          <div className={styles.row}>
            <input
              placeholder="Full Name"
              value={formData.applicant2?.name || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "name", e.target.value)
              }
            />
            <input
              placeholder="Phone"
              value={formData.applicant2?.phone || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "phone", e.target.value)
              }
            />
            <input
              placeholder="Email"
              value={formData.applicant2?.email || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "email", e.target.value)
              }
            />
          </div>

          <div className={styles.row}>
            <input
              type="date"
              placeholder="Date of Birth"
              value={formData.applicant2?.dob || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "dob", e.target.value)
              }
            />
            <select
              value={formData.applicant2?.maritalStatus || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "maritalStatus", e.target.value)
              }
            >
              <option value="">Marital Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Defacto">Defacto</option>
              <option value="Separated">Separated</option>
            </select>
            <select
              value={formData.applicant2?.residency || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "residency", e.target.value)
              }
            >
              <option value="">Residency Status</option>
              <option value="Citizen">Citizen</option>
              <option value="Permanent Resident">Permanent Resident</option>
              <option value="Temporary Resident">Temporary Resident</option>
            </select>
          </div>

          <div className={styles.row}>
            <input
              placeholder="Employer"
              value={formData.applicant2?.employer || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "employer", e.target.value)
              }
            />
            <input
              placeholder="Income ($)"
              type="number"
              value={formData.applicant2?.income || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "income", e.target.value)
              }
            />
            <select
              value={formData.applicant2?.employmentType || ""}
              onChange={(e) =>
                updateApplicant("applicant2", "employmentType", e.target.value)
              }
            >
              <option value="">Employment Type</option>
              <option value="PAYG Full-time">PAYG Full-time</option>
              <option value="PAYG Part-time">PAYG Part-time</option>
              <option value="Casual">Casual</option>
              <option value="Self-Employed">Self-Employed</option>
              <option value="Contractor">Contractor</option>
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

export default Applicants;
